import {useEffect, useState} from 'react';
import {useAuth} from '../../../helpers/AuthContext';
import {taxQuery} from './taxExport';

export default function useSellerTax(filters) {
  const {fetch: authFetch, API_URL} = useAuth();
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [revision, setRevision] = useState(0);
  const query = taxQuery(filters);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError('');
    setReport(null);
    async function load() {
      try {
        const response = await authFetch(`${API_URL}/v1/seller/tax?${query}`);
        const body = await response.json();
        if (!response.ok) throw new Error(body.message || body.error || 'Unable to load tax report.');
        if (active) setReport(body);
      } catch (failure) {
        if (active) setError(failure.message || 'Unable to load tax report.');
      } finally {
        if (active) setLoading(false);
      }
    }
    load();
    return () => { active = false; };
  }, [API_URL, authFetch, query, revision]);

  return {meta: report?.meta, rows: report?.data || [], loading, error,
    reload: () => setRevision(value => value + 1)};
}
